import React from 'react';
import { Table } from 'antd';

export  function CustomAntdTableTemp({
  columns,
  dataSource,
  rowKey = 'id',
  pagination = false,
  loading = false,
  bordered = true,
  size = 'middle',
  ...restProps
}) {
  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      rowKey={rowKey}
      pagination={pagination}
      loading={loading}
      bordered={bordered}
      size={size}
      {...restProps}
    />
  );
}
